import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import Img from './Img';
import Typography from './Typography';
import './Hero.scss';
import validate from '../utils/label-validator';
import defaultPropValues from '../helper/defaultPropValues';

const Hero = (props) => {
	const data = { ...defaultPropValues.heroProps.data, ...props.data };
	const {
		title,
		subtitle,
		body,
		footer,
		link,
		linkLabel,
		path,
		alt,
		contentWidth,
		imageMaxHeight
	} = data;

	const labels = useLabels();

	const contentWidthClasses = () => {
		if (
			contentWidth === undefined ||
			Object.keys(contentWidth).length === 0
		)
			return '';

		let classes = '';
		const classesArray = Object.keys(contentWidth);
		classesArray.forEach((breakpoint) => {
			if (contentWidth[breakpoint] === 0) return classes;
			classes += `col-${breakpoint}-${contentWidth[breakpoint]} `;
			return classes;
		});
		return classes;
	};

	return (
		<div className="ws-content-rows-hero">
			<div
				className="hero-background"
				style={{ overflow: 'hidden', maxHeight: imageMaxHeight }}
			>
				<Img src={path} alt={labels.get(alt)} />
			</div>
			<div
				className={`hero-content pl-sm-5 px-6 pr-sm-0 pb-5 pb-sm-0 text-center text-sm-left ${contentWidthClasses(
					contentWidth
				)}`}
			>
				{validate(title) && (
					<Typography
						className="hero-heading"
						weight="normal"
						variant="h2"
					>
						{labels.getHTML(title)}
					</Typography>
				)}
				{validate(subtitle) && (
					<Typography variant="h3">
						{labels.getHTML(subtitle)}
					</Typography>
				)}
				{validate(body) && (
					<Typography variant="p">{labels.getHTML(body)}</Typography>
				)}
				{validate(footer) && (
					<Typography variant="p">
						{labels.getHTML(footer)}
					</Typography>
				)}
				{validate(link) && (
					<a href={link} target="_blank" rel="noopener noreferrer">
						{labels.getHTML(linkLabel)}
					</a>
				)}
			</div>
		</div>
	);
};

export const HeroProps = {
	data: propTypes.shape({
		title: propTypes.string,
		path: propTypes.string,
		alt: propTypes.string,
		subtitle: propTypes.string,
		body: propTypes.string,
		footer: propTypes.string,
		link: propTypes.string,
		linkLabel: propTypes.string,
		contentWidth: propTypes.shape({}),
		imageMaxHeight: propTypes.string
	}).isRequired
};
Hero.propTypes = HeroProps;

export default Hero;
